<template>
  <div class="CompanyGenerateAll">
    <Header></Header>
    <div class="CompanyHomeBg">
      <img alt="" src="@a/aicompany/images/bg1.jpg" />
    </div>
    <div class="CompanyHome_content">
      <div class="CompanyHome_content_form">
        <div class="content_form_left">
          <!-- 城市选择 -->
          <div class="form_left_list city">
            <div class="left_list_title">
              <img alt="" src="@a/aicompany/images/bn20.png" />
              <div class="list_title_right">
                <el-cascader
                  placeholder="请选择城市"
                  size="large"
                  :options="options"
                  v-model="selectedCity"
                  @change="handleChange"
                  filterable
                  :show-all-levels="false"
                  >
                </el-cascader>
              </div>
            </div>
          </div>
          <div class="form_left_icon"></div>
          <!-- 行业选择 -->
          <div class="form_left_list industry">
            <div class="left_list_title">
              <img alt="" src="@a/aicompany/images/bn21.png" />
              <div class="list_title_right">
                <el-input
                  v-model="selectedIndustry"
                  placeholder="请选择/输入行业"
                  @focus="onInputFocus"
                  @blur="onInputBlur"
                ></el-input>
                <i class="el-input__icon el-icon-arrow-down"></i>
              </div>
            </div>
            <div class="left_list_down" v-if="showIndustryDropdown">
              <div class="list_down_bottom scroll">
                <!-- 遍历 categories 渲染分类和内容 -->
                <div
                  class="down_bottom_list"
                  v-for="(category, index) in categories"
                  :key="index"
                >
                  <div class="bottom_list_left">{{ category.name }}</div>
                  <div class="bottom_list_right">
                    <div
                      class="list_right_li"
                      :class="{ active: activeItem === item }"
                      v-for="(item, subIndex) in category.items"
                      :key="subIndex"
                      @click="selectCategory(item)"
                    >
                      {{ item }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form_left_icon"></div>
        </div>
        <div class="content_form_right">
          <input
              type="text"
              placeholder="例:一家专注于半导体研发生产的科技公司"
              v-model="description"
          />
          <div class="form_right_btn">
            <div class="right_btn_loding" v-show="loding"><div data-loader="circle-side"></div>生成中...</div>
            <div class="right_btn_click" @click="getUniqueId">继续生成</div>
          </div>
        </div>
      </div>
    </div>
<!--    <div class="CompanyGenerateprogress"></div>-->
    <div class="CompanyGenerateprogress" :style="{ width: progress + '%' }"></div>

    <div class="NotLogged" v-show="showNotLogged">
      <div class="NotLogged_content">
        <div class="NotLogged_btn" @click="">登录查看所有<img alt="" src="@a/aicompany/images/sv3.svg" /></div>
      </div>
    </div>

    <div class="CompanyGenerate hover scroll">
      <div
          class="CompanyGenerate_list"
          v-for="(item, index) in list"
          :key="index"
          :class="{ active: item.active }"
          @click="toggleClass(index)"
      >
        <div class="CompanyGenerate_list_left">
          <!-- 显示序号 + 标题 -->
          {{ index + 1 }}. {{ item.left }}
        </div>
        <div class="CompanyGenerate_list_right">
          <img alt="" src="@a/aicompany/images/sv2.svg" />备选查重
        </div>
      </div>
    </div>
    <div class="CompanyPBtn hover">
      <div class="CompanyPBtn_active">
        <div class="CompanyPBtn_list_loding" v-show="loding"><div data-loader="circle-side"></div>生成中...</div>
        <div class="CompanyPBtn_list_btn" @click="getUniqueId"><span><img alt="" src="@a/aicompany/images/sv7.svg" /><img alt="" src="@a/aicompany/images/sv7on.svg" /></span>继续生成</div>
      </div>
      <div class="CompanyPBtn_list" @click="goToCompanyGenerate" ><span><img alt="" src="@a/aicompany/images/sv6.svg" /><img alt="" src="@a/aicompany/images/sv6on.svg" /></span>一键查重({{ selectedCompanyCount }})</div>
      <div class="CompanyPBtn_list" @click="exportToExcel"><span><img alt="" src="@a/aicompany/images/sv5.svg" /><img alt="" src="@a/aicompany/images/sv5on.svg" /></span>导出</div>
    </div>
  </div>
</template>

<script>
import Header from '@c/aiCompanyheader/aiCompanyheader';
import * as XLSX from 'xlsx';
import { pcTextArr } from 'element-china-area-data'


export default {
  name: 'CompanyGenerate',
  data() {
    return {
      //加载效果
      loding: true,
      // 城市选择数据
      options: this.customizeCityData(pcTextArr),
      selectedCity: [],

      // 行业选择数据
      showIndustryDropdown: false,
      input: '',
      selectedIndustry: '', // 选中的行业
      activeItem: null, // 当前选中的类目
      // 所有分类和内容数组
      categories: [
        {
          name: "常用类",
          items: [
            "网络科技",
            "电子商务",
            "投资",
            "咨询",
            "广告",
            "零售",
            "制造",
            "餐饮",
            "文化",
          ],
        },
        {
          name: "科技类",
          items: [
            "网络科技",
            "电子科技",
            "化工科技",
            "环保科技",
            "能源科技",
            "新能源科技",
            "环境科技",
            "教育科技",
            "生物科技",
            "智能科技",
            "金融科技",
            "信息科技",
            "软件",
            "游戏",
          ],
        },
        {
          name: "金融类",
          items: [
            "投资",
            "融资",
            "保险",
            "货币金融",
            "资本市场服务",
          ],
        },
        {
          name: "商贸类",
          items: [
            "医疗器械",
            "机械设备",
            "游乐设备",
            "电子电器",
            "电子产品",
            "电子商务",
            "运输设备",
            "建材",
            "商贸",
            "贸易",
            "工贸",
            "国际贸易",
            "零售",
            "销售",
          ],
        },
        {
          name: "服务类",
          items: [
            "食品",
            "餐饮",
            "租赁",
            "住宿",
            "物流",
            "房地产",
            "人力资源",
            "建筑装潢",
            "美容美发",
            "翻译",
            "礼仪服务",
            "劳动派遣",
            "物业管理",
            "商务服务",
            "房屋经纪",
            "专利代理",
            "人才发展",
            "广告",
            "设计",
            "平面设计",
            "广告设计",
            "形象设计",
            "市场营销",
            "修理服务",
          ],
        },
        {
          name: "咨询类",
          items: [
            "财务咨询",
            "商务咨询",
            "科技咨询",
            "技术咨询",
            "税务咨询",
            "工程咨询",
            "会计咨询",
            "投资咨询",
            "投资咨询",
            "产业咨询",
            "健康咨询",
            "医疗咨询",
            "建筑咨询",
            "企业管理咨询",
          ],
        },
        {
          name: "产品类",
          items: [
            "服饰",
            "袜业",
            "箱包",
            "家具",
            "木业",
            "礼品",
            "工艺品",
            "化妆品",
            "汽配",
            "汽车用品",
            "电子产品",
            "电子电器",
          ],
        },
        {
          name: "管理类",
          items: [
            "商务管理",
            "置业管理",
            "建设管理",
            "企业管理",
            "投资管理",
            "财务管理",
            "品牌管理",
            "风险管理",
            "认证管理",
            "环境管理",
            "医院管理",
            "社会管理",
            "公共管理",
          ],
        },
        {
          name: "教育类",
          items: [
            "教育",
            "文化教育",
            "艺术教育",
          ],
        },
        {
          name: "文娱类",
          items: [
            "娱乐",
            "文化",
            "体育",
            "电影电视",
            "新闻",
          ],
        },
        {
          name: "信息类",
          items: [
            "信息网络",
            "数码信息",
            "信息发展",
            "劳动信息网络",
            "通信信息",
            "信息装备",
            "航旅信息",
            "交通信息",
          ],
        },
        {
          name: "工程类",
          items: [
            "建筑工程",
            "建筑安装工程",
            "建筑装饰工程",
            "设备安装",
            "机电工程",
            "市政工程",
            "电气设备",
            "工程设备",
            "机械设备",
            "运输设备",
          ],
        },
        {
          name: "跨五大行业实业类",
          items: [
            "实业",
            "企业发展",
            "实业发展",
            "经济发展",
          ],
        },
        {
          name: "其他产业类",
          items: [
            "农业",
            "渔业",
            "畜牧业",
            "林业",
            "采矿业",
            "制造业",
            "供应业",
          ],
        },
      ],

      // 描述输入数据
      description: "",
      // 从localStorage获取unique_id
      unique_id: localStorage.getItem('unique_id'),
      clickCount: 0,
      list: [], // 生成的公司名称列表
      progress: 1, // 进度条的百分比（0-100）
    };
  },
  created() {
    // 初始化 showNotLogged，根据登录状态设置
    this.showNotLogged = !this.$store.getters.isLogin;

    this.loadFromLocalStorage();
  },
  watch: {
    // 监听 Vuex 的登录状态变化
    '$store.getters.isLogin'(newVal) {
      this.showNotLogged = !newVal;
    },
  },
  mounted() {
    // 检查unique_id是否存在
    if (this.unique_id) {
      // 创建EventSource来接收流式数据
      const eventSource = new EventSource(`https://api.ai-dog.net/api/CompanyTitleBaidu/getTitle?unique_id=${this.unique_id}`);

      // 更新进度条到 10% 表示开始请求
      this.updateProgress(5);

      eventSource.onmessage = (event) => {
        const data = JSON.parse(event.data);  // 解析JSON数据

        // 如果返回的data包含标题
        if (data.title) {
          // 将生成的标题添加到列表
          this.list.push({ left: data.title, active: false });

          // 滚动到新增加的项
          this.$nextTick(() => {
            const container = this.$el.querySelector('.CompanyGenerate');
            if (container) {
              container.scrollTop = container.scrollHeight;
            }
          });

          // 这里你可以根据需要进一步操作，比如更新active状态等
          this.updateProgress(this.progress + 5); // 每次接收到数据，进度条增加
        }

        // 如果返回的是end标志，关闭连接
        if (event.data === 'end') {
          console.log("进度条为完成");
          this.updateProgress(100); // 设置进度条为完成
          eventSource.close();
        }
      };

      // 监听错误事件
      eventSource.onerror = (error) => {
        console.error("EventSource failed:", error);
        eventSource.close();
      };
    }
  },
  components: {
    Header
  },
  computed: {
    // 计算选中的公司数量
    selectedCompanyCount() {
      //如果没有选中的公司，则返回0
      if (!this.list || this.list.length === 0) {
        return 0;
      }
      return this.list.filter((item) => item.active).length;
    },
  },

  methods: {
    customizeCityData(data) {
      // 需要特殊处理的直辖市和新增城市
      const targetCities = ['北京市', '天津市', '重庆市', '上海市'];

      // 正则表达式移除后缀，包括“省”“市”“自治区”“自治州”“特别行政区”等及族名
      const suffixes = /(省|市|自治区|特别行政区|自治州|彝族|壮族|回族|维吾尔|藏族|傣族景颇族|傈僳族|白族|纳傣族|苗族|古族)$/;

      // 新增城市
      const additionalCities = [
        { label: '台湾', children: [{ label: '台湾', value: '台湾' }] },
        { label: '香港', children: [{ label: '香港', value: '香港' }] },
        { label: '澳门', children: [{ label: '澳门', value: '澳门' }] }
      ];

      // 合并现有数据和新增城市
      return data.concat(additionalCities).map(region => {
        if (targetCities.includes(region.label)) {
          // 对特定城市进行独立处理
          return {
            label: region.label.replace('自治区', '').replace('自治州', '').replace(suffixes, ''), // 去掉“自治区”及其他后缀
            value: region.label.replace('自治区', '').replace('自治州', '').replace(suffixes, ''), // 去掉“自治区”及其他后缀
            children: [{ 
              label: region.label.replace('自治区', '').replace('自治州', '').replace(suffixes, ''), // 去掉“自治区”及其他后缀
              value: region.label.replace('自治区', '').replace('自治州', '').replace(suffixes, '').toLowerCase() 
            }]
          };
        }

        // 对其他区域保持不变，同时去掉“自治州”后缀
        return {
        ...region,
          label: region.label.replace('自治区', '').replace('自治州', '').replace(suffixes, ''), // 去掉“自治区”及其他后缀
          value: region.label.replace('自治区', '').replace('自治州', '').replace(suffixes, ''), // 去掉“自治区”及其他后缀
          children: region.children
          ? region.children.map(child => ({
              ...child,
              label: child.label.replace('自治区', '').replace('自治州', '').replace(suffixes, '') 
            }))
          : []
        };
      });
    },


    // 切换行业下拉菜单
    // 输入框聚焦时显示下拉菜单
    onInputFocus() {
      this.showIndustryDropdown = true;
    },
    // 输入框失焦时隐藏下拉菜单
    onInputBlur() {
      setTimeout(() => {
        this.showIndustryDropdown = false;
      }, 200);
    },
    // 选中类目时处理逻辑
    selectCategory(item) {
      this.activeItem = item; // 设置当前激活的类目
      this.selectedIndustry = item; // 将选中的值赋值给输入框
    },
    handleChange (value) {
      console.log(value)
    },
    async goToCompanyGenerate() {

      try {

        //如果没有选中的公司，则返回
        if (this.selectedCompanyCount === 0) {
          alert('请至少选择一个公司');
          return;
        }

        //把存储的公司名字传给后端接口
        const response = await this.axios.post('api/CompanyName/getCheckCount', {
          uniqueId: this.unique_id,
          companyNames: JSON.parse(localStorage.getItem('selectedCompanies'))
        });

        // 使用 axios 发送 POST 请求，将数据传给后端接口
        //const response = await this.axios.get('api/CompanyName/getCheckCount');

        // 判断接口响应
        if (response && response.code === 1) {
          // 跳转到目标页面
          await this.$router.push('/aicompany/CompanyDuplicateCheck/CompanyDuplicateCheck');
        } else {
          alert(response.msg || '接口返回错误')
        }
      } catch (error) {
        alert('请求失败：' + error.message);
      }

    },
    // 生成中
    toggleClass(index) {
      // 获取当前的激活状态
      const currentActive = this.list[index].active;

      // 计算当前选中的公司数量
      const selectedCount = this.list.filter(item => item.active).length;

      // 如果当前已经选中 10 个公司，则不能再选中更多
      if (!currentActive && selectedCount >= 10) {
        alert('最多选中 10 个公司');
        return;
      }

      // 切换选中状态
      this.list[index].active = !currentActive;

      // 更新 localStorage，存储选中的公司名称
      this.saveSelectedCompanies();
    },

    // 将选中的公司名称存储到 localStorage
    saveSelectedCompanies() {
      const selectedCompanies = this.list
          .filter(item => item.active)   // 获取已选中的公司
          .map(item => item.left);       // 提取公司名称

      // 存储选中的公司名称到 localStorage
      localStorage.setItem('selectedCompanies', JSON.stringify(selectedCompanies));
    },
    // 切换城市下拉菜单
    toggleDropdown() {
      this.showCityDropdown = !this.showCityDropdown;
    },
    // 选择城市
    selectCity(city) {
      this.selectedCity = city;
      this.showCityDropdown = false; // 关闭下拉菜单
    },
    // 切换行业下拉菜单
    toggleIndustryDropdown() {
      this.showIndustryDropdown = !this.showIndustryDropdown;
    },
    // 选择行业
    selectIndustry(industry) {
      this.selectedIndustry = industry;
      this.showIndustryDropdown = false; // 关闭下拉菜单
    },
    // 确认输入的行业
    confirmIndustry() {
      if (this.industryInput.trim()) {
        this.selectedIndustry = this.industryInput;
        this.industryInput = ""; // 清空输入框
        this.showIndustryDropdown = false; // 关闭下拉菜单
      }
    },
    // 确认输入的关键词
    confirmKeyword() {
      if (this.keywordInput.trim()) {
        this.keyword = this.keywordInput;
        this.keywordInput = ""; // 清空输入框
      }
    },

    // 保存所有数据到 localStorage
    saveToLocalStorage() {
      const data = {
        selectedCity: this.selectedCity,
        selectedIndustry: this.selectedIndustry,
        description: this.description, // 添加描述
      };
      localStorage.setItem('CompanyHomeData', JSON.stringify(data));
    },

    // 加载数据从 localStorage
    loadFromLocalStorage() {
      const data = JSON.parse(localStorage.getItem('CompanyHomeData'));
      if (data) {
        this.selectedCity = data.selectedCity || "";
        this.selectedIndustry = data.selectedIndustry || "";
        this.description = data.description || ""; // 加载描述
      }
    },

    async getUniqueId() {
      try {
        // 每点击一次，计数器增加
        this.clickCount += 1;

        // 如果点击次数超过4次，显示提示
        if (this.clickCount >= 4) {
          alert("没有满意的可以更换关键词");
          //return; // 可以阻止继续执行后续操作
        }

        // 保存数据到 localStorage（可选，如果需要在本地存储中保留这些数据）
        this.saveToLocalStorage();

        // 准备发送的数据
        const dataToSend = {
          selectedCity: this.selectedCity || "",  // 默认空字符串
          selectedIndustry: this.selectedIndustry || "",
          description: this.description || "",  // 加载描述
          uniqueId: this.unique_id
        };

        // 使用 axios 发送 POST 请求，将数据传给后端接口
        const response = await this.axios.post('api/CompanyName/createCompanyName', dataToSend);

        // 判断接口响应
        if (response && response.code === 1) {
          console.log('接口响应：', response);
          // 把后端返回的 unique_id 存起来
          //localStorage.setItem('unique_id', response.result.unique_id);

          // 获取 unique_id 后再请求 getTitle 接口
          await this.fetchCompanyTitles(response.result.unique_id);
        } else {
          console.error("接口返回错误:", response);
          alert(response.msg || '接口返回错误');
        }
      } catch (error) {
        console.error('请求失败：', error);
        alert('请求失败：' + error.message);
        // 可添加错误处理逻辑，如弹出提示等
      }
    },

    // 获取公司标题
    async fetchCompanyTitles(unique_id) {
      try {
        // 通过 unique_id 请求获取公司标题
        const eventSource = new EventSource(`https://api.ai-dog.net/api/CompanyTitleBaidu/getTitle?unique_id=${unique_id}`);

        // 更新进度条到 10% 表示开始请求
        this.updateProgress(5);

        eventSource.onmessage = (event) => {
          const data = JSON.parse(event.data);  // 解析返回的JSON数据

          // 如果返回的data包含标题
          if (data.title) {
            // 将生成的标题添加到 list 数组
            this.list.push({ left: data.title, active: false });
            
            // 滚动到新增加的项
            this.$nextTick(() => {
              const container = this.$el.querySelector('.CompanyGenerate');
              if (container) {
                container.scrollTop = container.scrollHeight;
              }
            });

            // 你可以根据需要进一步操作，比如更新 active 状态等
            this.updateProgress(this.progress + 5); // 每次接收到数据，进度条增加
          }

          // 如果返回的是 end 标志，关闭连接
          if (event.data === 'end') {
            this.updateProgress(100); // 设置进度条为完成
            eventSource.close();
          }
        };

        // 监听错误事件
        eventSource.onerror = (error) => {
          console.error("EventSource failed:", error);
          eventSource.close();
        };
      } catch (error) {
        console.error('获取公司标题失败:', error);
        alert('获取公司标题失败：' + error.message);
      }
    },

    // 导出 Excel 方法
    exportToExcel() {
      // 将生成的企业名称数据提取为一个数组
      const data = this.list.map((item, index) => ({
        "序号": index + 1,
        "企业名称": item.left
      }));

      // 创建工作表
      const ws = XLSX.utils.json_to_sheet(data);

      // 创建工作簿
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "企业名称");

      // 导出 Excel 文件
      XLSX.writeFile(wb, "企业名称.xlsx");
    },

    // 更新进度条的方法
    updateProgress(value) {
      this.progress = Math.min(value, 100); // 确保进度不会超过 100%
      console.log('进度' + this.progress);
      if (this.progress === 100) {
          console.log('恭喜您进度100%');
          this.loding = false;
      } else {
        this.loding = true; 
      }
    },

  },
}


</script>

<style>

@import "CompanyGenerate.css";

.CompanyGenerate {
  max-height: calc(100vh - 280px);
  overflow-y: auto;
  padding-right: 10px;
}

</style>




